import ActivityBookingContext from '@/contexts/activityBookingContext';
import VoucherBookingContext from '@/contexts/voucherBookingContext';
import { FTunnelPageBookingTypeEnum } from '@/types/tunnel';
import { use } from 'react';
const useInternalTunnelBookingFilters = (bookingType) => {
    const activityBooking = use(ActivityBookingContext);
    const voucherBooking = use(VoucherBookingContext);
    const bookingContext = bookingType === FTunnelPageBookingTypeEnum.voucher ? voucherBooking : activityBooking;
    const { filters, completion, calculatedPrice } = bookingContext;
    return {
        filters: filters,
        completion: completion,
        calculatedPrice
    };
};
export default useInternalTunnelBookingFilters;
